import { useLocation, useNavigate } from "react-router-dom";

import ProfileWizard from "../components/ProfileWizard";
import { resolveRouteStateReturnTo } from "../lib/appHeaderRoutes";

export default function ProfileSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = resolveRouteStateReturnTo(location.state, "/home");

  const closePage = () => {
    navigate(returnTo, { replace: true });
  };

  return <ProfileWizard mode="settings" onComplete={closePage} onCancel={closePage} />;
}
